import { useAuth } from "@/contexts/AuthProvider";
import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import type { OrderType } from "@/types/order";
import { isSameDay, subDays } from "date-fns";

const fetchOrders = async (token: string): Promise<OrderType[]> => {
  const response = await axios.get("https://kaman.rest/api/auth/orders", {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  const orders = response.data.data.flat().map((order: any) => {
    return {
      id: order.id,
      order_number: order.order_number,
      payment_method: order.payment_method,
      status: order.status,
      total_price: order.total_price,
      order_items: order.order_items.map((item: any) => ({
        item_id: item.item_id,
        item_name_ar: item.item_name_ar,
        item_name_en: item.item_name_en,
        item_price: item.item_price,
      })),
      created_at: new Date(order.created_at),
    };
  });

  return orders;
};

export const useOrders = () => {
  const { token } = useAuth();

  return useQuery<OrderType[]>({
    queryKey: ["orders"],
    queryFn: () => fetchOrders(token as string),
    staleTime: 1000 * 60 * 5,
    enabled: !!token,
  });
};
